import { useMemo } from 'react';
import useAuthStore from '@pkg/auth/useStore';
import getFeatures from './get/features';
import getModel from './get/model';
import getPermissions from './get/permissions';

const DEFAULT_STATE = Object.freeze({
  isRestricted: true,
  features: {},
  model: {
    budget: false, // can see budgets
    edit: false, // can modify organisation
    manage: false, // can manage organisation
  },
});

/**
 * @returns {Object}
 */
export default function useAccess() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const organisation = useAuthStore((state) => state.organisation);
  const me = useAuthStore((state) => state.me);
  const assignedFeatures = useAuthStore((state) => state.features);

  return useMemo(() => {
    if (!isAuthenticated) {
      return DEFAULT_STATE;
    }

    const permissions = getPermissions(organisation.uuid);
    const model = getModel(me, permissions);
    const features = getFeatures(assignedFeatures);

    return Object.freeze({
      isRestricted: organisation.is_restricted,
      features,
      model,
    });
  }, [me, organisation, isAuthenticated, assignedFeatures]);
}
